/* Kaufkarten Premium – kleine zugängliche UI-Hilfen. Shopify übernimmt den eigentlichen Checkout. */
(() => {
  'use strict';
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.getElementById('MobileMenu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
      menuToggle.setAttribute('aria-label', expanded ? 'Menü öffnen' : 'Menü schließen');
      mobileMenu.hidden = expanded;
    });
  }
  document.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(button => {
    button.addEventListener('click', () => {
      const input = button.closest('.quantity-picker')?.querySelector('input[type="number"]');
      if (!input) return;
      const current = parseInt(input.value, 10) || 1;
      input.value = String(Math.max(1, current + (button.hasAttribute('data-qty-plus') ? 1 : -1)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  document.querySelectorAll('[data-product-thumb]').forEach(button => {
    button.addEventListener('click', () => {
      const main = document.querySelector('[data-product-main-image]');
      if (!main) return;
      main.src = button.dataset.src;
      main.alt = button.dataset.alt || main.alt;
      document.querySelectorAll('[data-product-thumb]').forEach(x => x.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });
  document.querySelectorAll('[data-variant-select]').forEach(select => {
    const refresh = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const currency = select.dataset.currency || 'EUR';
      const format = cents => new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(Number(cents) / 100);
      const price = document.querySelector('[data-product-price]');
      if (price) price.textContent = format(option.dataset.price);
      const compare = document.querySelector('[data-compare-price]');
      if (compare) {
        compare.textContent = Number(option.dataset.compare) > Number(option.dataset.price) ? format(option.dataset.compare) : '';
      }
      const addButton = document.querySelector('[data-add-button]');
      const available = option.dataset.available === 'true';
      if (addButton) {
        addButton.disabled = !available;
        addButton.innerHTML = available ? 'In den Warenkorb <span aria-hidden="true">↗</span>' : 'Ausverkauft';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    };
    select.addEventListener('change', refresh);
  });
  document.querySelectorAll('[data-auto-submit]').forEach(input => {
    input.addEventListener('change', () => input.form?.submit());
  });
})();
